<template>
  <Wrap>
    <FormFloat :title="title">
      <Notice v-if="message" :class="message.theme">
        {{ message.text }}
      </Notice>
      <Route v-if="!isVerifying" class="Btn success" to="Login">
        {{ $t('login') }}
      </Route>
    </FormFloat>
  </Wrap>
</template>

<script>
import FormFloat from '@forms/FormFloat'
import Message from '@mixins/Message'
import Meta from '@mixins/Meta'
import { actions } from '@utils'

export default {
  mixins: [
    Message,
    Meta(),
  ],
  components: { FormFloat },
  data() {
    return {
      isVerifying: true,
      hasVerified: false,
    }
  },
  computed: {
    title() {
      if (this.isVerifying) return this.$t('checking')
      if (this.hasVerified) return this.$t('verified')
      return this.$t('error')
    },
  },
  methods: actions('PATCH_AUTHMANAGEMENT'),
  mounted() {
    return this.$wrap(
      async () => {
        await this.PATCH_AUTHMANAGEMENT({
          id: null,
          verifyToken: this.$route.query.token,
        })

        this.hasVerified = true
        this.success(this.$t('success'))
      },
      'isVerifying',
    )
  },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "meta": {
      "title": "Successfully signed up"
    },
    "login": "Login",
    "checking": "Checking verification code",
    "updating": "Updating your account",
    "verified": "Successfully verified",
    "success": "Welcome aboard! You can now login.",
    "error": "Verification error"
  }
}
</i18n>
